<div class="button">
  <div class="icon" [style.--icon]="iconUrl"></div>
  <div *ngIf="label" class="text">{{ label }}</div>
</div>
